import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EarthIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#earth-1__a)",
                            children: _jsx("path", {
                                d: "M23.345 11.935v-.02c-.02-2.99-1.2-5.81-3.32-7.93a11.263 11.263 0 00-6.2-3.17c-.08-.02-.15-.05-.23-.05h-.04c-.51-.07-1.03-.12-1.56-.12-3.03 0-5.88 1.18-8.02 3.32a11.34 11.34 0 00-3.32 8.05c0 3.03 1.18 5.88 3.32 8.02a11.27 11.27 0 008.02 3.32c3.03 0 5.88-1.18 8.02-3.32a11.27 11.27 0 003.32-8.02v-.08h.01zm-17.95-6.53a9.273 9.273 0 016.61-2.74c.2 0 .4.02.59.03v2.55a1.777 1.777 0 01-1.78 1.78c-1.01 0-1.96.39-2.68 1.11a3.76 3.76 0 00-1.11 2.68v2.39c0 .24-.05.47-.14.68-.09.22-.22.41-.39.58a1.799 1.799 0 01-1.26.53h-2.09a9.31 9.31 0 01-.49-2.98c0-2.5.97-4.84 2.74-6.61zm0 13.22c-.5-.5-.93-1.05-1.29-1.63h1.14c.5 0 .99-.1 1.45-.29.46-.19.88-.47 1.23-.82s.63-.77.82-1.23c.19-.46.29-.95.29-1.45v-2.39a1.777 1.777 0 011.78-1.78c1 0 1.97-.4 2.68-1.11a3.76 3.76 0 001.11-2.68v-2.21c1.5.43 2.88 1.23 4.02 2.37a9.29 9.29 0 012.59 4.98c-.47-.11-.95-.17-1.43-.17h-3.39c-1.01 0-1.96.39-2.68 1.11a3.76 3.76 0 00-1.11 2.68c0 1.01.4 1.97 1.11 2.68.71.72 1.67 1.11 2.68 1.11.26 0 .51.1.7.29.19.19.29.44.29.7v.88a9.285 9.285 0 01-5.37 1.7c-2.5 0-4.85-.97-6.61-2.74h-.01zm13.84-.69a2.956 2.956 0 00-2.86-2.15c-.48 0-.92-.19-1.26-.52-.34-.33-.52-.79-.52-1.26s.19-.93.52-1.26c.34-.34.79-.52 1.26-.52h3.39c.53 0 1.06.1 1.56.28-.11 1.98-.84 3.9-2.09 5.44v-.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "earth-1__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
EarthIcon.isCarinaIcon = true;
export default EarthIcon;
